export const ARIA_SuccessCode = "00";
export const ARIA_NOT_FOUND = "1004";
export const ARIA_RESERVATION_NOT_FOUND = "3000";
export const ARIA_RESERVATION_ALREADY_PREREGISTERED = "3001";
export const ARIA_PMS_CONNECTOR_ERROR = "3009";
export const FORCE_GUEST_PAY_AT_COUNTER = "3016";